import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

// if the config file has a typo, you'll get weird errors here :(
const ENDPOINT = `${process.env.API_ENDPOINT}api/v1/`;

/** --------------------
 *
 *    Helper functions
 *
 * --------------------- */

const getRequest = (url, token) => Vue.http
  .get(`${ENDPOINT}${url}`, { headers: { Authorization: `Bearer ${token}` } })
  .then(res => res.json());

const postRequest = (url, token, body) => Vue.http.post(`${ENDPOINT}${url}`, body, {
  headers: { Authorization: `Bearer ${token}` }
});

const putRequest = (url, token, body) => Vue.http.put(`${ENDPOINT}${url}`, body, {
  headers: { Authorization: `Bearer ${token}` }
});

const deleteRequest = (url, token) => Vue.http.delete(`${ENDPOINT}${url}`, {
  headers: { Authorization: `Bearer ${token}` }
});

const postAndGetFile = (url, body, token) => Vue.http.post(`${ENDPOINT}${url}`, body, {
  responseType: 'arraybuffer',
  headers: { Authorization: `Bearer ${token}` }
});

const getScores = (searchBody, token) => postRequest(`reporting/survey-run-scores`, token, searchBody);

const getElementScores = (element, searchBody, token) => postRequest(`reporting/elements/${encodeURI(element)}/scores`, token, searchBody);

const getElementNames = (token) => getRequest(`reporting/elements`, token);

const getComments = (surveyRunIds, dimensionData, token) => postRequest(`survey-runs/${surveyRunIds.length > 1 ? 'multiple' : surveyRunIds[0]}/comments/analyze?surveyRunId=${surveyRunIds.length > 1 ? JSON.stringify(surveyRunIds) : ''}`, token, dimensionData);

export {
  getScores, 
  getElementNames,
  getElementScores,
  getComments
};



// WEBPACK FOOTER //
// ./src/services/Reporting.js